import * as React from 'react';
import { MessageBarType } from '@fluentui/react';

export interface MessageBannerProps {
  message: { text: string; type: MessageBarType };
  isFading: boolean;
  onDismiss: () => void;
}

const getMessageClass = (type: MessageBarType): string => {
  switch (type) {
    case MessageBarType.success:
      return 'success';
    case MessageBarType.error:
      return 'error';
    case MessageBarType.warning:
      return 'warning';
    default:
      return '';
  }
};

const MessageBanner: React.FC<MessageBannerProps> = ({ message, isFading, onDismiss }) => {
  return (
    <div className={`info-banner ${getMessageClass(message.type)} ${isFading ? 'fading' : ''}`}>
      <span className="material-icons-round banner-icon">info</span>
      <div className="banner-content">
        <p className="banner-text">{message.text}</p>
      </div>
      <button className="banner-close" onClick={onDismiss}>
        <span className="material-icons-round">close</span>
      </button>
    </div>
  );
};

export default MessageBanner;
